const characters = {
  example: {
    name: '다크원더러',
    tier: 5,
    children: [
      {
        name: '로열가드',
        tier: 4,
        children: [
          {
            name: '디펜더',
            tier: 3,
            children: [
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '아처',
                    tier: 1
                  }
                ]
              },
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '랜서',
                    tier: 1
                  }
                ]
              },
            ]
          },
          {
            name: '디펜더',
            tier: 3,
            children: [
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '아처',
                    tier: 1
                  }
                ]
              },
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '랜서',
                    tier: 1
                  }
                ]
              },
            ]
          },
        ]
      },
      {
        name: '로열가드',
        tier: 4,
        children: [
          {
            name: '디펜더',
            tier: 3,
            children: [
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '아처',
                    tier: 1
                  }
                ]
              },
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '랜서',
                    tier: 1
                  }
                ]
              },
            ]
          },
          {
            name: '디펜더',
            tier: 3,
            children: [
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '아처',
                    tier: 1
                  }
                ]
              },
              {
                name: '팔라딘',
                tier: 2,
                children: [
                  {
                    name: '소드맨',
                    tier: 1
                  },
                  {
                    name: '랜서',
                    tier: 1
                  }
                ]
              },
            ]
          },
        ]
      }
    ]
  },
  data: [
    /**
     * 1성
     */
    {
      name: '소드맨',
      tier: 1,
    },
    {
      name: '아처',
      tier: 1,
    },
    {
      name: '로그',
      tier: 1,
    },
    {
      name: '위저드',
      tier: 1,
    },
    {
      name: '클레릭',
      tier: 1,
    },
    {
      name: '파이터',
      tier: 1,
    },
    {
      name: '랜서',
      tier: 1,
    },
    {
      name: '스피릿',
      tier: 1,
    },

    /**
     * 2성
     */
    {
      name: '팔라딘',
      tier: 2,
      ingridients: [
        '소드맨', '클레릭'
      ]
    },
    {
      name: '가디언',
      tier: 2,
      ingridients: [
        '랜서', '소드맨'
      ]
    },
    {
      name: '닌자',
      tier: 2,
      ingridients: [
        '로그', '스피릿'
      ]
    },
    {
      name: '드루이드',
      tier: 2,
      ingridients: [
        '클레릭', '파이터'
      ]
    },
    {
      name: '바바리안',
      tier: 2,
      ingridients: [
        '파이터', '소드맨'
      ]
    },
    {
      name: '샤먼',
      tier: 2,
      ingridients: [
        '위저드', '파이터'
      ]
    },
    {
      name: '인챈터',
      tier: 2,
      ingridients: [
        '스피릿', '위저드'
      ]
    },
    {
      name: '소서러',
      tier: 2,
      ingridients: [
        '위저드', '클레릭'
      ]
    },
    {
      name: '어쌔신',
      tier: 2,
      ingridients: [
        '로그', '로그'
      ]
    },
    {
      name: '펜서',
      tier: 2,
      ingridients: [
        '랜서', '로그'
      ]
    },
    {
      name: '스펠소드',
      tier: 2,
      ingridients: [
        '소드맨', '위저드'
      ]
    },
    {
      name: '체이서',
      tier: 2,
      ingridients: [
        '아처', '랜서'
      ]
    },
    {
      name: '스나이퍼',
      tier: 2,
      ingridients: [
        '아처', '아처'
      ]
    },
    {
      name: '몽크',
      tier: 2,
      ingridients: [
        '파이터', '스피릿'
      ]
    },
    {
      name: '바드',
      tier: 2,
      ingridients: [
        '클레릭', '아처'
      ]
    },

    /**
     * 3성
     */
    {
      name: '디펜더',
      tier: 3,
      ingridients: [
        '팔라딘', '가디언', '닌자'
      ]
    },
    {
      name: '워든',
      tier: 3,
      ingridients: [
        '드루이드', '바바리안', '가디언'
      ]
    },
    {
      name: '에스퍼',
      tier: 3,
      ingridients: [
        '샤먼', '샤먼', '인챈터'
      ]
    },
    {
      name: '워락',
      tier: 3,
      ingridients: [
        '소서러', '어쌔신', '인챈터'
      ]
    },
    {
      name: '램페이저',
      tier: 3,
      ingridients: [
        '펜서', '스펠소드', '체이서'
      ]
    },
    {
      name: '글레디에이터',
      tier: 3,
      ingridients: [
        '바바리안', '스나이퍼', '소서러'
      ]
    },
    {
      name: '프리스트',
      tier: 3,
      ingridients: [
        '클레릭', '클레릭', '클레릭'
      ]
    },
    {
      name: '헌터',
      tier: 3,
      ingridients: [
        '체이서', '가디언', '몽크'
      ]
    },
    {
      name: '레인저',
      tier: 3,
      ingridients: [
        '체이서', '바바리안', '인챈터'
      ]
    },
    {
      name: '인보커',
      tier: 3,
      ingridients: [
        '소서러', '바드', '팔라딘'
      ]
    },
    {
      name: '하이스피릿',
      tier: 3,
      ingridients: [
        '스피릿', '스피릿', '스피릿'
      ]
    },
    {
      name: '슬레이어',
      tier: 3,
      ingridients: [
        '어쌔신', '몽크', '샤먼'
      ]
    },
    {
      name: '스카우트',
      tier: 3,
      ingridients: [
        '스나이퍼', '스나이퍼', '체이서'
      ]
    },
    {
      name: '크루세이더',
      tier: 3,
      ingridients: [
        '팔라딘', '드루이드', '펜서'
      ]
    },
    {
      name: '네크로맨서',
      tier: 3,
      ingridients: [
        '샤먼', '스나이퍼', '소서러'
      ]
    },
    {
      name: '민스트럴',
      tier: 3,
      ingridients: [
        '바드', '드루이드', '드루이드'
      ]
    },
    {
      name: '스트라이커',
      tier: 3,
      ingridients: [
        '몽크', '스펠소드', '스나이퍼'
      ]
    },
    {
      name: '룬나이트',
      tier: 3,
      ingridients: [
        '스펠소드', '바바리안', '샤먼'
      ]
    },
    {
      name: '하이랜더',
      tier: 3,
      ingridients: [
        '스펠소드', '팔라딘', '바드'
      ]
    },
    {
      name: '사무라이',
      tier: 3,
      ingridients: [
        '닌자', '펜서', '인챈터'
      ]
    },
    {
      name: '어벤져',
      tier: 3,
      ingridients: [
        '어쌔신', '닌자', '체이서'
      ]
    },
    {
      name: '룬마스터',
      tier: 3,
      ingridients: [
        '몽크', '닌자', '가디언'
      ]
    },
    {
      name: '버서커',
      tier: 3,
      ingridients: [
        '바바리안', '닌자', '바드'
      ]
    },
    {
      name: '라이더',
      tier: 3,
      ingridients: [
        '가디언', '어쌔신', '펜서'
      ]
    },
    {
      name: '마에스트로',
      tier: 3,
      ingridients: [
        '랜서', '랜서', '랜서'
      ]
    },
    {
      name: '서번트',
      tier: 3,
      ingridients: [
        '인챈터', '스펠소드', '어쌔신'
      ]
    },


    /**
     * 4성
     */
    {
      name: '로열가드',
      tier: 4,
      ingridients: [
        '디펜더', '워든', '에스퍼'
      ]
    },
    {
      name: '엘드리치',
      tier: 4,
      ingridients: [
        '워락', '램페이저', '글레디에이터'
      ]
    },
    {
      name: '비숍',
      tier: 4,
      ingridients: [
        '프리스트', '헌터', '워든'
      ]
    },
    {
      name: '레이븐',
      tier: 4,
      ingridients: [
        '레인저', '글레디에이터', '인보커'
      ]
    },
    {
      name: '실프',
      tier: 4,
      ingridients: [
        '하이스피릿', '슬레이어', '스카우트'
      ]
    },
    {
      name: '아케인아처',
      tier: 4,
      ingridients: [
        '레인저', '크루세이더', '네크로맨서'
      ]
    },
    {
      name: '오라클',
      tier: 4,
      ingridients: [
        '민스트럴', '에스퍼', '스트라이커'
      ]
    },
    {
      name: '발키리',
      tier: 4,
      ingridients: [
        '룬나이트', '서번트', '사무라이'
      ]
    },
    {
      name: '블레이드싱어',
      tier: 4,
      ingridients: [
        '크루세이더', '프리스트', '룬나이트'
      ]
    },
    {
      name: '윈드워커',
      tier: 4,
      ingridients: [
        '스카우트', '램페이저', '하이랜더'
      ]
    },
    {
      name: '커세어',
      tier: 4,
      ingridients: [
        '헌터', '스카우트', '버서커'
      ]
    },
    {
      name: '드래곤슬레이어',
      tier: 4,
      ingridients: [
        '슬레이어', '룬마스터', '버서커'
      ]
    },
    {
      name: '섀도우댄서',
      tier: 4,
      ingridients: [
        '사무라이', '사무라이', '하이스피릿'
      ]
    },
    {
      name: '스내쳐',
      tier: 4,
      ingridients: [
        '사무라이', '디펜더', '하이랜더'
      ]
    },
    {
      name: '트릭스터',
      tier: 4,
      ingridients: [
        '어벤져', '민스트럴', '하이스피릿'
      ]
    },
    {
      name: '하이어쌔신',
      tier: 4,
      ingridients: [
        '어벤져', '스트라이커', '슬레이어'
      ]
    },
    {
      name: '드래곤샤먼',
      tier: 4,
      ingridients: [
        '에스퍼', '마에스트로', '레인저'
      ]
    },
    {
      name: '미스틱',
      tier: 4,
      ingridients: [
        '에스퍼', '사무라이', '라이더'
      ]
    },
    {
      name: '다크프리스트',
      tier: 4,
      ingridients: [
        '프리스트', '민스트럴', '디펜더'
      ]
    },
    {
      name: '바이킹',
      tier: 4,
      ingridients: [
        '글레디에이터', '마에스트로', '룬나이트'
      ]
    },
    {
      name: '뱅가드',
      tier: 4,
      ingridients: [
        '마에스트로', '슬레이어', '램페이저'
      ]
    },
    {
      name: '포트리스',
      tier: 4,
      ingridients: [
        '라이더', '룬마스터', '스카우트'
      ]
    },
    {
      name: '샐러맨더',
      tier: 4,
      ingridients: [
        '하이스피릿', '워락', '인보커'
      ]
    },
    {
      name: '알케미스트',
      tier: 4,
      ingridients: [
        '서번트', '프리스트', '룬마스터'
      ]
    },
    {
      name: '운디네',
      tier: 4,
      ingridients: [
        '하이스피릿', '레인저', '룬마스터'
      ]
    },
    {
      name: '데스나이트',
      tier: 4,
      ingridients: [
        '하이랜더', '디펜더', '라이더'
      ]
    },
    {
      name: '소울이터',
      tier: 4,
      ingridients: [
        '네크로맨서', '에스퍼', '서번트'
      ]
    },
    {
      name: '아크메이지',
      tier: 4,
      ingridients: [
        '인보커', '스트라이커', '버서커'
      ]
    },
    {
      name: '워셰이퍼',
      tier: 4,
      ingridients: [
        '워든', '하이랜더', '네크로맨서'
      ]
    },
    {
      name: '디스트로이어',
      tier: 4,
      ingridients: [
        '버서커', '글레디에이터', '크루세이더'
      ]
    },
    {
      name: '챔피언',
      tier: 4,
      ingridients: [
        '스트라이커', '디펜더', '마에스트로'
      ]
    },
    {
      name: '템플러',
      tier: 4,
      ingridients: [
        '룬마스터', '민스트럴', '인보커'
      ]
    },
    {
      name: '룰러',
      tier: 4,
      ingridients: [
        '마에스트로', '워락', '라이더'
      ]
    },
    {
      name: '트라이던트',
      tier: 4,
      ingridients: [
        '램페이저', '헌터', '어벤져'
      ]
    },
    {
      name: '엑소시스트',
      tier: 4,
      ingridients: [
        '서번트', '헌터', '워든'
      ]
    },


    /**
     * 5성
     */
    {
      name: '다크원더러',
      tier: 5,
      ingridients: [
        '레이븐', '아케인아처', '실프'
      ]
    },
    {
      name: '블랙발큐리아',
      tier: 5,
      ingridients: [
        '발키리', '포트리스', '운디네'
      ]
    },
    {
      name: '소드마스터',
      tier: 5,
      ingridients: [
        '블레이드싱어', '드래곤슬레이어', '바이킹'
      ]
    },
    {
      name: '팔콘',
      tier: 5,
      ingridients: [
        '커세어', '엘드리치', '워셰이퍼'
      ]
    },
    {
      name: '더비시',
      tier: 5,
      ingridients: [
        '섀도우댄서', '블레이드싱어', '미스틱'
      ]
    },
    {
      name: '루나블레이드',
      tier: 5,
      ingridients: [
        '하이어쌔신', '바이킹', '트라이던트'
      ]
    },
    {
      name: '다크로드',
      tier: 5,
      ingridients: [
        '다크프리스트', '템플러', '엘드리치'
      ]
    },
    {
      name: '비스트로드',
      tier: 5,
      ingridients: [
        '워셰이퍼', '레이븐', '하이어쌔신'
      ]
    },
    {
      name: '아크엔젤',
      tier: 5,
      ingridients: [
        '비숍', '아크메이지', '샐러맨더'
      ]
    },
    {
      name: '갓핸드',
      tier: 5,
      ingridients: [
        '챔피언', '드래곤슬레이어', '엑소시스트'
      ]
    },
    {
      name: '헬브링거',
      tier: 5,
      ingridients: [
        '디스트로이어', '오라클', '드래곤샤먼'
      ]
    },
    {
      name: '실피드',
      tier: 5,
      ingridients: [
        '실프', '트릭스터', '알케미스트'
      ]
    },
    {
      name: '드라군',
      tier: 5,
      ingridients: [
        '로열가드', '발키리', '룰러'
      ]
    },
    {
      name: '소울보우',
      tier: 5,
      ingridients: [
        '윈드워커', '커세어', '데스나이트'
      ]
    },
    {
      name: '바운티헌터',
      tier: 5,
      ingridients: [
        '트릭스터', '섀도우댄서', '뱅가드'
      ]
    },
    {
      name: '로드메이지',
      tier: 5,
      ingridients: [
        '아크메이지', '오라클', '룰러'
      ]
    },
    {
      name: '뱀파이어',
      tier: 5,
      ingridients: [
        '드래곤샤먼', '데스나이트', '소울이터'
      ]
    },
    {
      name: '세이지',
      tier: 5,
      ingridients: [
        '소울이터', '미스틱', '다크프리스트'
      ]
    },
    {
      name: '메이지피스트',
      tier: 5,
      ingridients: [
        '템플러', '알케미스트', '비숍'
      ]
    },
    {
      name: '듀란달',
      tier: 5,
      ingridients: [
        '트라이던트', '엑소시스트', '디스트로이어'
      ]
    },
    {
      name: '워로드',
      tier: 5,
      ingridients: [
        '뱅가드', '윈드워커', '챔피언'
      ]
    },
    {
      name: '카발리어',
      tier: 5,
      ingridients: [
        '포트리스', '아케인아처', '로열가드'
      ]
    },
    {
      name: '엘라임',
      tier: 5,
      ingridients: [
        '운디네', '뱅가드', '오라클'
      ]
    },
    {
      name: '이프리트',
      tier: 5,
      ingridients: [
        '샐러맨더', '챔피언', '디스트로이어'
      ]
    },
  ],
  method: {
    cango(character, compareCharacter) {
      let mapped =  []
      characters.method.map(compareCharacter, mapped)
      return mapped.filter(_character => _character == character.name).length > 0
    },
    go(character) {
      return characters.data.filter(_character => {
        if (_character.ingridients) {
          let result = _character.ingridients.filter(__character => __character == character.name)
          return result.length
        }
        return false
      })
    },
    map2(character, mapped, findDepth, depth) {
      if (depth == findDepth) {
        mapped.push({
          name: character.name,
          sp: character.sp,
          tier: character.tier,
          children: character.children,
          ingridients: character.ingridients
        })
      } else {
        character.children.forEach(child =>{
          characters.method.map2(child, mapped, findDepth, depth - 1)
        })
        if (depth - 1 == findDepth) {
          mapped.push({
            invisible: true
          })
        }
      }
    },
    format(character) {
      character.children = []
      if (character.ingridients) {
        const first = characters.data.find(_character => _character.name == character.ingridients[0])
        if (first.tier + 1 < character.tier) {
          let cc = {
            name: false,
            ingridients: character.ingridients,
            children: []
          }
          character.children.push(cc)
          character.sp = true
          character = cc
        }

        character.ingridients.forEach(ingridient =>{
          const child = characters.data.find(character => character.name == ingridient)
          character.children.push(child)
          characters.method.format(child)
        })
      }
    },
    map(character, sum) {

      sum.push(character.name)
      if (character.ingridients) {
       
        character.ingridients.forEach(ingridient =>{
          const child = characters.data.find(character => character.name == ingridient)
          characters.method.map(child, sum)
        })
      }
    },
    assemblable(mapped, inventory, waypoint) {
      for (var i = 0; i < mapped.length; i ++) {
        const character = characters.data.find(character => character.name == mapped[i])
        if (characters.method.has(character, inventory) && !characters.method.enough(character, mapped, inventory, waypoint)) {
          return character
        }
      }
      return false
    },
    enough (character, mapped, inventory, waypoint) {
      var grouped = {}
      var mapped2 = []
      var grouped2 = {}
      characters.method.group(mapped, grouped)

      Object.keys(inventory).forEach(key => {
        for(var i = 0; i < inventory[key]; i ++) {
          let c = characters.data.find(character => character.name == key)
          characters.method.map(c, mapped2)
        }
      });

      characters.method.group(mapped2, grouped2)

      if (waypoint.name == character.name)
        return false

      if (grouped[character.name] <= grouped2[character.name])
        return true

      return grouped[character.name] <= inventory[character.name] 
    },
    has (character, inventory) {
      var inventoryClone = Object.assign({}, inventory);
      for (var i = 0; i < character.ingridients.length; i ++) {
        var name = character.ingridients[i]
        if (inventoryClone[name] > 0) {
          inventoryClone[name] --;
        } else {
          return false
        }
      }
      return true
    },
    group(sum, grouped) {
      for(var a in sum){
        if(grouped[sum[a]])grouped[sum[a]]++;
        else grouped[sum[a]]=1;
      }
    }
  }
}

export default characters;